import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { inquiriesRepository } from "@/features/inquiries/repository";

// Sidebar badge count. Polls slowly — the badge only needs to be eventually
// accurate; inquiry mutations invalidate the ["inquiries"] prefix anyway.
export function useSubmittedInquiryCount(): UseQueryResult<number> {
  return useQuery<number>({
    queryKey: ["inquiries", "count"],
    queryFn: () => inquiriesRepository.countSubmitted(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
